var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnlike = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13L11 22C11.7956 22 12.5587 21.6839 13.1213 21.1213C13.6839 20.5587 14 19.7956 14 19V15H19.66C19.9499 15.0033 20.2371 14.9435 20.5016 14.8248C20.7661 14.7061 21.0016 14.5313 21.1919 14.3125C21.3821 14.0937 21.5225 13.8362 21.6033 13.5577C21.6842 13.2793 21.7035 12.9866 21.66 12.7L20.28 3.7C20.2077 3.22309 19.9654 2.78839 19.5979 2.47599C19.2304 2.1636 18.7623 1.99455 18.28 2H7M7 13V2M7 13H4C3.46957 13 2.96086 12.7893 2.58579 12.4142C2.21071 12.0391 2 11.5304 2 11V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H7",
    stroke: "#0066CC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnlike);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unlike.cf69fbe29a1900bee65527a37ab05367.svg";